<template>
  <div>
    <b-row>
      <b-col cols="12">
        <RemediatedIddPlusCounterVueContainer />
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import { Helper } from "../../helpers";
import AppHeader from "../../components/header/header";
import RemediatedIddPlusCounterVueContainer from "../../containers/RemediatedIddPlusCounterVueContainer.vue";
// import { HTTP } from "../../utils/HTTP";
export default {
  name: "ClientProfileRemediation",
  components: {
    AppHeader,
    RemediatedIddPlusCounterVueContainer
  },
  data() {
    return {};
  },

  computed: {},
  methods: {}
};
</script>

<style scoped>
</style>
